var financeModule = angular.module('finance', ['common']);